import COPY from "./content/siteCopy.json";
import React, { useEffect, useState } from "react";
import { SmartLink } from "./SiteHeader";

const API = process.env.REACT_APP_BACKEND_URL;

export function HotTakeBand() {
  const [post, setPost] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/public/vault?topic=hot-takes&limit=1`).then((r) => (r.ok ? r.json() : null)).then((d) => setPost(d?.items?.[0] || null)).catch(() => {});
  }, []);
  if (!post) return null;
  const date = new Date(post.published_at).toLocaleDateString("en-CA", { month: "short", day: "numeric" });
  return (
    <section className="hottake" data-testid="home-hot-take">
      <div className="wrap">
        <div className="hottake-head intro">
          <img className="hottake-pepper" src="/brand/vault/icons/chili.png" alt="" aria-hidden="true" />
          <div><div className="eyebrow">{COPY.hot_takes.eyebrow}</div><h2 className="display">{COPY.hot_takes.heading}<br /><em>{COPY.hot_takes.heading_em}</em></h2></div>
          <p>{COPY.hot_takes.text}</p>
        </div>
        <SmartLink href={`/strategy-vault/${post.slug}/`} className="hottake-card" data-testid="home-hot-take-card">
          <div className="hottake-art"><img src={post.hero_image} alt="" loading="lazy" /></div>
          <div className="hottake-body">
            <span className="tag">Latest take · {date} · {post.reading_minutes} min read</span>
            <h3>{post.title}</h3>
            <div className="hottake-open">{(post.opening || [post.summary]).map((l, i) => <p key={i}>{l}</p>)}</div>
            <div className="hottake-foot">
              <span className="hottake-by"><img src="/brand/matt-broom-hall.png" alt="" width="36" height="36" onError={(e) => { e.currentTarget.style.display = "none"; }} /><span><strong>{post.author}</strong><br />Broker, opinion-haver</span></span>
              <span className="tool-link">Keep reading →</span>
            </div>
          </div>
        </SmartLink>
        <p className="hottake-all"><SmartLink href="/strategy-vault/topic/hot-takes/" className="textlink" data-testid="home-hot-take-all">All the hot takes</SmartLink></p>
      </div>
    </section>
  );
}
